<div class="row">
    <div class="col-lg-12">
        <h1>CRM Dashboard</h1>
    </div>
</div>

<div class="row">
    <div class="col-sm-3">
        <label class="k-font-weight-bold">Rep Type</label>
        <kendo-dropdownlist [data]="repTypes"
                            [(ngModel)]="selectedRepType"
                            (valueChange)="filterChanged()"></kendo-dropdownlist>
    </div>
    <div class="col-sm-3">
        <label class="k-font-weight-bold">Employee</label>
        <kendo-dropdownlist [data]="employees"
                            [textField]="'fullName'"
                            [valueField]="'employeeId'"
                            [valuePrimitive]="true"
                            [(ngModel)]="selectedEmployeeID"
                            [defaultItem]="blankEmployee"
                            (valueChange)="filterChanged()"></kendo-dropdownlist>
    </div>
</div>

<div class="row" style="margin-top:10px;">
    <div class="col-sm-12">
        <kendo-tabstrip (tabSelect)="onTabSelect($event)">
            <kendo-tabstrip-tab title="Home" [selected]="true">
                <ng-template kendoTabContent>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Accounts">
                <ng-template kendoTabContent>
                    <!--<customer-list [pageType]="'Accounts'" [repType]="selectedRepType" [employeeID]="selectedEmployeeID"></customer-list>-->
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Leads">
                <ng-template kendoTabContent>
                    <!--<customer-list [pageType]="'Leads'" [repType]="selectedRepType" [employeeID]="selectedEmployeeID"></customer-list>-->
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Prospects">
                <ng-template kendoTabContent>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Opportunities">
                <ng-template kendoTabContent>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Follow Ups">
                <ng-template kendoTabContent>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab title="Customer Actions">
                <ng-template kendoTabContent>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
</div>
